import styled from 'styled-components';

export const PageWrapperStyled = styled.div`
  width: 90%;
  margin: 0 auto;
  max-width: 160rem;
`;
